/*
 * @Description: KGAME 游戏框
 */
import React from 'react';
import { Rnd } from "react-rnd";
import Loader from '../../components/icon/Loader.jsx';

export default class KGameModal extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      width: 800, 
      height: 480, 
      x: document.documentElement.clientWidth - 800, 
      y: document.documentElement.clientHeight - 480 + document.documentElement.scrollTop,
      ratio: false, 
      moving: false
    }
  }

  componentDidMount() {
  }
  
  // 拖动开始
  onDragStart() {this.setState({moving: true})}

  // 拖动结束
  onDragStop(e, d) {
    const maxX = document.documentElement.clientWidth - parseInt(d.node.style.width);
    const maxY = document.documentElement.clientHeight - parseInt(d.node.style.height) + document.documentElement.scrollTop;
    this.setState({ 
      moving: false,
      x: d.x < 0 ? 0 : (d.x > maxX ? maxX : d.x), 
      y: d.y < 0 ? 0 : (d.y > maxY ? maxY : d.y) 
    })
  }

  // 修改尺寸
  onResize(e, direction, ref, delta, position) {
    this.setState({
      width: ref.style.width,
      height: ref.style.height,
      ...position
    })
  }

  // 开始修改尺寸
  onResizeStart(onStart, dir) {
    if(_.includes(['top', 'bottom', 'left', 'right'], dir)){
      this.setState({ratio: true})
    }else{
      this.setState({ratio: false})
    }
  }

  // 修改尺寸结束
  onResizeStop (e, direction, ref, delta, position) {
    this.setState({
      x: position.x < 0 ? 0 : position.x,
      y: position.y < 0 ? 0 : position.y
    })
  }

  // 最小化
  setMinSize() {
    const client = document.documentElement;
    this.setState({
      ratio: false, 
      width: 280, 
      height: 200, 
      x: client.clientWidth - 280, 
      y: client.clientHeight - 200 + document.documentElement.scrollTop 
    })
  }

  // 最大化
  setMaxSize() {
    const client = document.documentElement;
    this.setState({ratio: false, width: client.clientWidth, height: client.clientHeight, x: 0, y: document.documentElement.scrollTop })
  }

  render() {
    const {frameSrc, close, transferFn} = this.props;
    const {width, height, x, y, ratio, moving} = this.state;

    return (
      <Rnd
        minWidth={280}
        minHeight={200}
        className="kgame-modal"
        size={{ width: width, height: height }}
        position={{ x: x, y: y }}
        lockAspectRatio={ratio}
        dragHandleClassName="drag-header"
        onDragStop={this.onDragStop.bind(this)}
        onDragStart={this.onDragStart.bind(this)}
        onResize={this.onResize.bind(this)}
        onResizeStart={this.onResizeStart.bind(this)}
        onResizeStop={this.onResizeStop.bind(this)}
      >
        <header className='drag-header'>
          <div className="left">
            <span>KGAME</span>
            <span onClick={transferFn} className='trans'>转账</span>
          </div>
          <div className="right resize">
            <span onClick={this.setMinSize.bind(this)} />
            <span onClick={this.setMaxSize.bind(this)} />
            <span onClick={close} />
          </div>
        </header>
        <div className='frame-box' style={{width: `${parseInt(width)}px`, height: `${parseInt(height) - 32}px`}}>
          <div className="overlay-frame" style={{display: moving ? 'block' : 'none'}}></div>
          {
            frameSrc && <iframe src={frameSrc} />
          }
          {
            !frameSrc && <Loader />
          }
        </div>
      </Rnd>
    )
  }

  

}
